import { Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';

export default class DynamicNameUI extends Plugin {
	init() {
		const editor = this.editor;

        // Register the button in the editor's UI component factory.
		editor.ui.componentFactory.add( 'dynamicname', () => {
			const button = new ButtonView();
			
			button.label = 'Додати динамічне ім`я';
			button.tooltip = true;
			button.withText = true;

			this.listenTo(button, 'execute', () => {
				const textToInsert = '{{__USERNAME__}}';

				editor.model.change((writer) => {
					editor.model.insertContent(
						writer.createText(textToInsert)
					);
				});
			});

			return button;
		} );
	}
}